import { Chip } from '@mui/material'
import { useDefaultValue } from 'hooks/useDefaultValue'
import React from 'react'
import { getSkillLabel, mergeSkillGroups, SkillEntry } from 'services/jobSkills'
import { makeStyles } from 'tss-react/mui'

export interface IJobSkillsCollectionProps {
  skills: SkillEntry[]
  style?: React.CSSProperties
}

const useStyles = makeStyles()(theme => ({
  container: {
    '& > *': {
      margin: theme.spacing(0, 1, 1, 0),
    },
  },
}))

function JobSkillsCollection(props: IJobSkillsCollectionProps) {
  const { classes } = useStyles()
  let { skills, style } = props

  skills = useDefaultValue(skills, [])

  const mergedRequiredSkills = mergeSkillGroups(skills.filter(s => s.required))
  const optionalSkills = skills.filter(s => !s.required)
  const allSkills = mergedRequiredSkills.concat(optionalSkills)

  return (
    <div className={classes.container} style={style}>
      {allSkills.map(skill => (
        <Chip key={skill.skill_id} label={getSkillLabel(skill)} />
      ))}
    </div>
  )
}

export default React.memo(JobSkillsCollection)
